;(function () {
  angular
    .module('contrast.integrations')
    .directive('csIntegrationAutoCreateTickets', csIntegrationAutoCreateTickets)

  function csIntegrationAutoCreateTickets() {
    'ngInject'

    return {
      replace: true,
      restrict: 'E',
      templateUrl:
        'components/integrations/cs-integration-auto-create-tickets.html'
    }
  }
})()
